<template>
  <div class="fts-list-view-form" v-if="isShow">
    <div class="list-view-form__header">
      <div class="form-header__left">  
        <div class="form-header__uppr">
          <div 
            class="form-header__activity" 
            v-if="selectedActivity && selectedActivity.name"
          >
            {{selectedActivity.name}}
          </div>

          <div 
            class="form-header__title" 
            v-if="!selectedActivity || selectedActivity.id !== 'create'"
          >{{title || '(Untitled)'}}</div>

          <fts-state
            :state="header.state"
            :states="states"
            :tint="true"
            class="form-header__state"
            v-if="header && header.state && header.state.name"
          ></fts-state>

          <fts-tippy 
            content="Edit action" 
            append-trigger-class="form-header__design-btn" 
            @trigger:click="openActionDesignDrawer" 
            v-if="isDesignMode && selectedActivity && selectedActivity.id"
          >
            <span class="material-icons-outlined">edit</span>
          </fts-tippy>
        </div>

        <div class="form-header__lowr">
          <!-- audit -->
          <fts-tippy
            :options="{ placement: 'bottom-start' }" 
            append-trigger-class="audit-group__trigger" 
            append-content-class="audit-group__content" 
            class="fts-audit-group form-header__audit" 
            v-if="header && header.audit"
          >
            <template>
              <fts-profile 
                :user-name="header.audit.updatedBy" 
                :profile-photo-size="14"
              />
              <div class="audit-group-date">
                {{moment(header.audit.updatedDate).fromNow()}}
              </div>
            </template>

            <template slot="content">
              <fts-profile :profilePhotoSize="26" :user-name="header.audit.updatedBy" class="audit-group-wrapper">
                <div slot="profileName" slot-scope="{ userProfileName }" class="audit-group-info">
                  <div>{{userProfileName}}</div>
                  <div class="audit-group-date">updated on {{moment(header.audit.updatedDate).format('llll')}}</div>
                </div>
              </fts-profile>

              <fts-profile :profilePhotoSize="26" :user-name="header.audit.createdBy" class="audit-group-wrapper">
                <div slot="profileName" slot-scope="{ userProfileName }" class="audit-group-info">
                  <div>{{userProfileName}}</div>
                  <div class="audit-group-date">created on {{moment(header.audit.createdDate).format('llll')}}</div>
                </div>
              </fts-profile>
            </template>
          </fts-tippy>
        </div>
      </div>

      <div class="form-header__right">
        <!-- form sync -->
        <fts-form-sync 
          :synchronize="$refs.activityClassification.synchronize" 
          class="form-header__sync form-header__item"
          v-if="
            selectedActivity &&
            !(['assign', 'changeStatus', 'duplicate', 'delete'].indexOf(selectedActivity.id) > -1) &&
            $refs.activityClassification
          "
        ></fts-form-sync>

        <template v-if="header && !isError && !isMultiple">
          <!-- comment -->
          <fts-tippy
            content="Comment" 
            :append-trigger-class="
              historyMode === 'comment' ? 
                'form-header__action-btn form-header__action-btn--active' : 
                'form-header__action-btn'
            " 
            @trigger:click="toggleHistory('comment')" 
            v-if="isCommentRight"
          >
            <span class="material-icons-outlined">mode_comment</span>
          </fts-tippy>
          <!-- history -->
          <fts-tippy
            content="History" 
            :append-trigger-class="
              historyMode === 'history' ? 
                'form-header__action-btn form-header__action-btn--active' : 
                'form-header__action-btn'
            " 
            @trigger:click="toggleHistory('history')" 
            v-if="isHistoryRight"
          >
            <span class="material-icons-outlined">history</span>
          </fts-tippy>
        </template>

        <!-- close -->
        <fts-tippy 
          content="Close" 
          append-trigger-class="form-header__action-btn" 
          @trigger:click="beforeCloseForm"
        >
          <span class="material-icons-outlined">close</span>
        </fts-tippy>
      </div>
    </div>

    <div class="list-view-form__content">
      <div class="form-content__form inistate-scroller" ref="form-content">
        <div class="form-content__form-container">
          <template v-if="!selectedActivity">
            <!-- AutoCount Full's lock (402 connector_full_required): not an error -->
            <fts-connector-lock-card :lock="viewFormLock" v-if="viewFormError && viewFormLock" />
            <div class="dv-form-error" v-else-if="viewFormError">
              <div class="dv-form-error-icon">
                <font-awesome-icon :icon="['fas', 'times']" fixed-width />
              </div>
              <div class="dv-form-error-title">
                Something went wrong
              </div>
              <div class="dv-form-error-description">
                {{viewFormError}}
              </div>
            </div>

            <fts-classification 
              :locus-id="header && header.id" 
              :vector-id="moduleId" 
              :users="users" 
              :username="username" 
              :view="true" 
              :view-data="viewData" 
              :loading="isViewFormLoading" 
              :form-settings="{
                hideLabelIcon: true
              }" 
              class="form-content__form-view" 
              v-else-if="viewData"
            />
          </template>

          <template v-if="selectedActivity && selectedActivity.id">
            <fts-connector-lock-card :lock="activityFormLock" v-if="activityFormError && activityFormLock" />
            <div class="dv-form-error" v-else-if="activityFormError">
              <div class="dv-form-error-icon">
                <font-awesome-icon :icon="['fas', 'times']" fixed-width />
              </div>
              <div class="dv-form-error-title">
                Something went wrong
              </div>
              <div class="dv-form-error-description">
                {{activityFormError}}
              </div>
            </div>

            <template v-else>
              <div 
                class="form__content-details" 
                :class="{'form__content-details--active': isActivityViewForm}" 
                v-if="
                  selectedActivity.id != 'create' && 
                  !isMultiple && 
                  !isActivityFormLoading
                "
              >
                <div 
                  class="form__content-details-toggle" 
                  @click="toggleActivityViewForm(!isActivityViewForm)"
                >
                  <div class="form__content-details-toggle-label">Details</div>
                  <div class="form__content-details-toggle-icon">
                    <span class="material-icons-outlined" style="font-size: 20px;">keyboard_arrow_down</span>
                  </div>
                </div>

                <fts-transition-expand>
                  <div class="form__content-details-content" v-if="isActivityViewForm">
                    <fts-spinner 
                      :size="26" 
                      class="form__content-details-content-loading" 
                      v-if="isViewFormLoading" 
                    />

                    <div class="dv-form-error" v-else-if="viewFormError">
                      <div class="dv-form-error-icon">
                        <font-awesome-icon :icon="['fas', 'times']" fixed-width />
                      </div>
                      <div class="dv-form-error-title">
                        Something went wrong
                      </div>
                      <div class="dv-form-error-description">
                        {{viewFormError}}
                      </div>
                    </div>

                    <fts-classification 
                      :locus-id="header && header.id" 
                      :vector-id="moduleId" 
                      :users="users" 
                      :username="username" 
                      :view="true" 
                      :view-data="viewData" 
                      :form-settings="{
                        hideLabelIcon: true
                      }" 
                      class="form-content__form-view" 
                      v-else
                    />
                  </div>
                </fts-transition-expand>
              </div>

              <div 
                class="dv-form-activity" 
                v-if="['assign', 'changeStatus', 'duplicate', 'delete'].includes(selectedActivity.id)" 
              >
                <div class="dv-form-activity-content">
                  <div class="dv-form-activity-label fts-text-center" v-if="selectedActivity.id == 'delete'">
                    Are you sure to delete?
                  </div>

                  <div class="dv-form-activity-label fts-text-center" v-else-if="selectedActivity.id == 'duplicate'">
                    Are you sure to duplicate?
                  </div>

                  <div class="dv-form-activity-state" v-else-if="selectedActivity.id == 'changeStatus'">
                    <div class="dv-form-activity-label-group">
                      <div class="dv-form-activity-label">
                        Change state to
                      </div>

                      <fts-dropdown-select
                        append-to-body
                        prevent-overflow-alt-axis
                        prevent-overflow-tether-off
                        v-model="formData.selectedState"
                        :options="states"
                      >
                        <fts-state
                          slot="toggle"
                          slot-scope="{ selectedOption }"
                          :state="
                            selectedOption && selectedOption.name ?
                              selectedOption :
                              { name: 'select state' }
                          "
                          :states="states"
                        />

                        <div
                          slot="option"
                          slot-scope="{ option, select }"
                          class="dropdown-option"
                          @click="select(option)"
                        >
                          <fts-state :state="option" />
                        </div>

                      </fts-dropdown-select>
                    </div>

                    <div
                      class="fts-form-error"
                      v-if="
                        $v.formData &&
                        $v.formData.selectedState &&
                        $v.formData.selectedState.$error
                      "
                    >
                      State is required.
                    </div>
                  </div>

                  <fts-assign
                    :assign-data="formData"
                    v-else-if="selectedActivity.id == 'assign'"
                  />
                </div>

                <fts-comment
                  :vector-id="moduleId"
                  :comment="comment"
                  v-if="isCommentRight && selectedActivity.id !== 'duplicate'"
                />
              </div>

              <fts-classification 
                :locus-id="header && header.id" 
                :vector-id="moduleId" 
                :users="users" 
                :username="username" 
                :activity="selectedActivity.name" 
                :activity-id="selectedActivity.id" 
                :view="!isCapableOf(SYSTEM_CAPABILITY.Write)" 
                :comment="comment" 
                :comment-section="isCommentRight" 
                :loading="isActivityFormLoading" 
                :form-settings="{
                  hideLabelIcon: true
                }"
                class="form-content__form-activity" 
                @submit="submit" 
                ref="activityClassification" 
                v-else
              />
            </template>
          </template>
        </div>

        <div class="form-content__form-footer" v-if="selectedActivity && selectedActivity.id">
          <fts-form-footer 
            :activity="selectedActivity" 
            :sync-state="$refs.activityClassification && $refs.activityClassification.syncState" 
            :loading="$refs.activityClassification && $refs.activityClassification.isFormLoading" 
            :submitting="formSubmitting" 
            :is-lite="true" 
            :disable-cancel="true" 
            @synchronize="evt => ($refs.activityClassification && $refs.activityClassification.synchronize(evt))" 
            @sync:submit="$refs.activityClassification && $refs.activityClassification.submit()" 
            @submit="submit" 
          ></fts-form-footer>
        </div>

        <div 
          class="form-content__form-footer" 
          v-if="
            !isViewFormLoading && 
            !isError && 
            !selectedActivity && (
              (footer.activities && footer.activities.length) ||
              (footer.customs && footer.customs.length) ||
              (footer.documents && footer.documents.length)
            )
          "
        >
          <fts-form-footer-buttons
            :activities="footer.activities"
            :customs="footer.customs"
            :documents="footer.documents" 
            :design-mode="isDesignMode" 
            @execute:activity="evt => executeFormAction(evt, 'activity')" 
            @execute:custom="evt => executeFormAction(evt, 'custom')" 
            @execute:document="evt => executeFormAction(evt, 'template')" 
          ></fts-form-footer-buttons>
        </div>
      </div>

      <fts-history 
        :key="header.id" 
        :locus-id="header.id" 
        :vector-id="moduleId" 
        :states="states" 
        :users="users" 
        :comment-section="isCommentRight" 
        :enable-notification="false" 
        :init-open="getHistoryInitOpen()" 
        class="form-content__history" 
        @added="historyAdded" 
        @mode:change="setHistoryMode" 
        ref="ftsHistory" 
        v-if="
          isHistoryRight &&
          !isMultiple &&
          !isError
        "
      />
    </div>

    <div class="list-view-form__overlay" v-if="isFormLoading || formSubmitting">
      <fts-spinner show />
    </div>

    <fts-form-message-modal ref="ftsFormMessageModal" />
  </div>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
Vue.use(Vuelidate);
import moment from 'moment';
import isFormDirty from "../../commons/formDirty";

import commons from '../../commons/commons';
import { isCapableOf, SYSTEM_CAPABILITY } from '../../commons/flags';
import { classificationStore } from '../../store/classificationStore';
import { authorizationStore } from '../../store/authorizationStore';
import { clientStore } from '../../store/clientStore';
import LocalStorageService from '../../store/LocalStorageService';
import { openActivityPortalHere } from '../../portals/activityPortalHere';
import confetti from '../../commons/confetti';

import FTSBtn from '../FTSBtn';
import FTSClassification from '../FTSClassification';
import FTSTippy from '../FTSTippy';
import FTSProfile from '../FTSProfile';
import FTSFormSync from '../form/FTSFormSync';
import FTSHistory from '../../lite/history/FTSHistory';
import FTSFormFooter from '../form/FTSFormFooter';
import FTSFormMessageModal from '../form/FTSFormMessageModal';
import FTSComment from '../FTSComment';
import FTSDropdownSelect from '../FTSDropdownSelect';
import FTSState from '../FTSState';
import FTSTransitionExpand from '../FTSTransitionExpand';
import FTSSpinner from '../FTSSpinner';
import FTSConnectorLockCard from '../FTSConnectorLockCard';
import { connectorLockFromError } from '../connectorLock';
import FTSFormFooterButtons from '../../lite/form/FTSFormFooterButtons';

const MODULE_UNAVAILABLE_MESSAGE = "Module you trying to access is unpublished or have been removed.";
const ENTRY_UNAVAILABLE_MESSAGE = "Entry you trying to access is not available. Please check with your administrator.";
const ACTIVITY_UNAVAILABLE_MESSAGE = "Entry not able to perform this activity. Please check with your administrator";
const CAPABILITY_UNAVAILABLE_MESSAGE = "401 Unauthorized. Access denied due to invalid credentials.";

const getSuccessMessage = (id, standard) => {
  if (standard) {
    if (id === 'create')
      return 'Successfully created';
    else if (id == 'edit')
      return 'Successfully updated';
    else if (id === 'delete')
      return 'Successfully deleted';
    else if (id === 'duplicate')
      return 'Successfully duplicated';
    else if (id === 'assign')
      return 'Successfully assigned';
  }
  return 'Submission successful';
}
const getErrorMessage = (id, standard) => {
  if (standard) {
    if (id === 'create')
      return 'Failed to create';
    else if (id === 'edit')
      return 'Failed to update';
    else if (id === 'delete')
      return 'Failed to delete';
    else if (id === 'duplicate')
      return 'Failed to duplicate';
    else if (id === 'assign')
      return 'Failed to assign';
  }
  return 'Submission failed';
}

export default {
  components: {
    'fts-btn': FTSBtn,
    'fts-classification': FTSClassification,
    'fts-tippy': FTSTippy,
    'fts-profile': FTSProfile,
    'fts-form-sync': FTSFormSync,
    'fts-history': FTSHistory,
    'fts-form-footer': FTSFormFooter,
    'fts-form-message-modal':FTSFormMessageModal,
    'fts-comment': FTSComment,
    'fts-dropdown-select': FTSDropdownSelect,
    'fts-state': FTSState,
    'fts-transition-expand': FTSTransitionExpand,
    'fts-spinner': FTSSpinner,
    'fts-connector-lock-card': FTSConnectorLockCard,
    'fts-form-footer-buttons': FTSFormFooterButtons
  },
  data:() => ({
    SYSTEM_CAPABILITY: Object.freeze(SYSTEM_CAPABILITY),
    isShow: false,
    moduleId: null,
    listingId: null,
    username: null,
    fullView: false,
    entries: [],
    items: [],
    header: {},
    footer: {},
    title: null,
    initialForm: null,
    // activity
    formData: {},
    comment: {},
    selectedActivity: null,
    isActivityFormLoading: false,
    activityFormNextStates: [],
    activityFormError: null,
    // the entry's module is on AutoCount Full and this workspace is not (402): a lock card instead
    activityFormLock: null,
    viewFormLock: null,
    formSubmitting: false,
    isActivityViewForm: false,
    // view
    viewData: null,
    isViewFormLoading: false,
    viewFormError: null,
    // history
    historyMode: null
  }),
  validations() {
    let formData = {};

    if (this.selectedActivity && this.selectedActivity.id == 'changeStatus') {
      formData = {
        selectedState: {
          name: { required }
        }
      }
    }

    return { formData };
  },
  methods: {
    moment,
    momentRelativeTime(date) {
      return commons.momentRelativeTime(date);
    },
    calendarRelativeTime(date) {
      return commons.calendarRelativeTime(date);
    },
    isCapableOf(type) {
      return isCapableOf(type, clientStore.getters.workspaceModules, this.moduelId);
    },
    isRightOf(type) {
      return type &&
        this.footer &&
        this.footer.standards &&
        this.footer.standards.indexOf(type) > -1;
    },
    resetContentScroll() {
      this.$refs["form-content"].scrollTo({ top: 0, left: 0 });
    },
    updateParentView() {
      window.eventBus.$emit("entry:updated", {
        moduleId: this.moduleId
      });
    },
    setRouter() {
      const setRouteQuery = (query) => {
        if (this.fullView) {
          query.m = "f";
        } else if (query.hasOwnProperty("m")) {
          delete query.m;
        }
      }

      if (this.selectedActivity && this.selectedActivity.id === 'create') {
        let query = {
          ...this.$route.query,
          a: 'create'
        };
        if (query.hasOwnProperty('id')) {
          delete query.id;
        }
        this.$router.push({ query: query });
      } else if (this.header && this.header.id) {
        let query = {
          ...this.$route.query,
          id: commons.queryEncodeids(this.moduleId, this.header.id)
        }

        setRouteQuery(query);

        if (this.selectedActivity) {
          query.a = this.selectedActivity.id;
        } else if (query.hasOwnProperty("a")) {
          delete query.a;
        }

        this.$router.push({ query: query });
      } else {
        let route = {
          name: 'list-view',
          params: {
            moduleId: commons.encodeids(this.moduleId)
          }
        }
        if (this.listingId) {
          route.query = { l: this.listingId };
        } 
        this.$router.push(route);
      }
    },
    setEntryHeader(data) {
      if (Array.isArray(data) && data.length > 0 && commons.isObject(data[0])) {
        this.header = data[0];
        this.entries = data;
      } else if (commons.isObject(data)) {
        this.header = data;
        this.entries = [data];
      } else {
        this.header = {};
        this.entries = [];
      }
    },
    initialFormData() {
      this.formData = {
        id: this.header.id,
        assignees: this.header.assignees,
        due: this.header.due
      }
    },
    async loadViewForm() {
      this.isViewFormLoading = true;
      try {
        if (!this.isCapableOf(SYSTEM_CAPABILITY.Read)) {
          throw { response: { data: { message: CAPABILITY_UNAVAILABLE_MESSAGE }, status: 400 }};
        }
        const res = await classificationStore.dispatch('loadViewForm', {
          moduleId: this.moduleId ? this.moduleId.toString() : null,
          listingId: this.listingId,
          activityId: this.fullView ? 'view' : 'quickView',
          entryId: this.header.id,
          locusId: this.header.id,
          query: this.$route.query,
          users: this.users
        });

        if (this.header.id != res.header.entryId) {
          console.warn(`Form view aborted: Entry mismatch detected. Expected document ID '${this.header.documentId}', but received '${res.header.documentId}'.`);
          return;
        }

        /* Opened without a module (a wildcard connection link — see SS05672): the server resolved
           it from the entry, so adopt it. Without this the state chips, module name and any later
           route push stay blank or entry-only. */
        if (!this.moduleId && res.header && res.header.moduleId) {
          this.moduleId = res.header.moduleId;
        }

        this.header = res.header;
        this.footer = res.footer;
        this.viewData = res.viewData;
        !this.isActivityViewForm && this.initialFormData();
        this.items = [{
          ...res.header, 
          extension: {...res.viewData && res.viewData.formData}
        }];

        if (Array.isArray(this.footer && this.footer.standards)) {
          let excludedStandards = [];

          if (!this.isCapableOf(SYSTEM_CAPABILITY.Write)) {
            excludedStandards.push(...["create", "edit", "changeStatus", "duplicate", "assign"]);
          }

          if (!this.isCapableOf(SYSTEM_CAPABILITY.Delete)) {
            excludedStandards.push("delete");
          }

          this.footer.standards = this.footer.standards.filter(x => !excludedStandards.includes(x));
        }

        if (Array.isArray(this.footer && this.footer.customs) && this.footer.customs.length) {
          this.footer.customs = commons.getFormAvailableCustoms(this.footer.customs, this.items);
        }

        this.viewFormError = null;
      } catch(err) {
        console.error('loadViewForm', err);
        this.viewFormLock = connectorLockFromError(err);
        if (
          err.response &&
          err.response.status == 400 &&
          err.response.data &&
          err.response.data.message
        ) {
          this.viewFormError = err.response.data.message;
        } else {
          this.viewFormError = ENTRY_UNAVAILABLE_MESSAGE;
        }
      } finally {
        this.isViewFormLoading = false;
      }
    },
    async loadActivityForm() {
      this.$v.$reset();
      this.comment = {};
      this.activityFormNextStates = [];
      this.isActivityFormLoading = true;
      this.isActivityViewForm = false;
      try {
        if (this.selectedActivity.id === "manage" && !this.isAdminUser) {
          throw { response: { data: { message: ACTIVITY_UNAVAILABLE_MESSAGE }, status: 400 }};
        }

        if (
          (this.selectedActivity.id === "delete" && !this.isCapableOf(SYSTEM_CAPABILITY.Delete)) ||
          (
            ["create", "edit", "changeStatus", "duplicate", "assign"].indexOf(this.selectedActivity.id) > -1 &&
            !this.isCapableOf(SYSTEM_CAPABILITY.Write)
          )
        ) {
          throw { response: { data: { message: CAPABILITY_UNAVAILABLE_MESSAGE }, status: 400 }};
        }

        const setForm = (result) => {
          this.header = result.header;
          this.footer = result.footer;
          this.initialFormData();
          // activity
          if (result.header && result.header.activity) {
            this.selectedActivity = result.header.activity;
          }
          // form sync
          if (result.needSync && this.selectedActivity) {
            this.$refs.activityClassification.pollData(this.selectedActivity);
          }
          // states
          if (this.states && this.states.length) {
            if (Array.isArray(this.footer.states) && this.footer.states.length) {
              this.activityFormNextStates = this.footer.states.map(x => this.states.find(y => y.id == x)).filter(y => y);
            }
          }
          // assignees
          if (Array.isArray(this.footer.assignees) && this.footer.assignees.length) {
            this.formData.assignees = this.footer.assignees;
          }
        }

        let payload = {
          moduleId: this.moduleId ? this.moduleId.toString() : null,
          listingId: this.listingId,
          activityId: this.selectedActivity.id,
          entryId: this.header.id,
          locusId: this.header.id,
          query: this.$route.query,
          users: this.users,
          enableCache: true,
          hasCache: false
        }

        if (this.selectedActivity.id == "create") {
          const cachedForm = classificationStore.getters.getCachedForm({
            moduleId: this.moduleId,
            activityId: this.selectedActivity.id
          });

          if (cachedForm) {
            classificationStore.dispatch("loadActivityFormCache", {
              setup: payload,
              data: cachedForm
            });
            setForm(cachedForm);
            payload.hasCache = true;
          }
        }

        if (payload.hasCache) {
          this.activityFormError = null;
          this.isActivityFormLoading = false;
        }

        const result = await classificationStore.dispatch('loadActivityForm', payload);
        if (this.header.id != result.header.entryId) {
          console.warn(`Form activity aborted: Entry mismatch detected. Expected document ID '${this.header.documentId}', but received '${result.header.documentId}'.`);
          return;
        }

        setForm(result);

        if (result.needCache) {
          classificationStore.dispatch("setCachedForm", {
            moduleId: this.moduleId,
            activityId: this.selectedActivity.id,
            data: result
          });
        } else {
          classificationStore.dispatch("clearCachedForm", {
            moduleId: this.moduleId,
            activityId: this.selectedActivity.id
          });
        }

        this.activityFormError = null;
        this.isActivityFormLoading = false;

        this.$nextTick(() => {
          const formData = _.cloneDeep(classificationStore.getters.formData);
          classificationStore.dispatch("setOriginalFormData", formData)
        });
      } catch(err) {
        console.error('loadActivityForm', err);

        if (axios.isCancel(err)) {
          return;
        }

        this.activityFormLock = connectorLockFromError(err);
        if (
          err.response &&
          err.response.status == 400 &&
          err.response.data &&
          err.response.data.message
        ) {
          this.activityFormError = err.response.data.message;
        } else {
          this.activityFormError = ACTIVITY_UNAVAILABLE_MESSAGE;
        }

        this.isActivityFormLoading = false;
      }
    },
    getHistoryInitOpen() {
      const preference = LocalStorageService.getModuleListingPreference(this.moduleId, this.listingId);
      if (preference && preference.hasOwnProperty("historyVisible")) {
        return preference.historyVisible;
      }
 
      return !!(this.header && this.header.commentCount && this.header.commentCount > 0);
    },
    setHistoryMode(mode) {
      this.historyMode = mode;
    },
    toggleHistory(mode) {
      if (this.$refs.ftsHistory) {
        this.$refs.ftsHistory.toggleHistory(mode);
        LocalStorageService.setModuleListingPreference(
          this.moduleId,
          this.listingId,
          {
            ...LocalStorageService.getModuleListingPreference(this.moduleId, this.listingId),
            historyVisible: Boolean(this.$refs.ftsHistory.show)
          }
        );
      }
    },
    historyAdded() {
      this.updateParentView();

      if (this.header.commentCount) {
        this.header.commentCount += 1;
      } else {
        this.header.commentCount = 1;
      }
    },
    async submit(formData) {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        this.formSubmitting = true;

        const result = await classificationStore.dispatch('submitActivity', {
          moduleId: (this.module && this.module.id)? this.module.id.toString() : null,
          activityId: this.selectedActivity.id,
          payload: formData,
          entryIds: this.entries.map((x) => x.id),
          post: this.comment,
          intention: this.comment.attention,
          state: this.formData.selectedState && this.formData.selectedState.name ? this.formData.selectedState.name : null,
          assignees: this.formData.assignees,
          due: this.formData.due ? moment(this.formData.due).endOf('day') : null,
          query: this.$route.query
        });

        this.formSubmitting = false;

        // confetti
        if (result.data.celebrate) {
          confetti();
        }
        // message
        if (result.data.message) {
          await this.$refs.ftsFormMessageModal.show(result.data.message);
        } else {
          this.$toasted.success(
            getSuccessMessage(this.selectedActivity.id, this.selectedActivity.standard)
          );
        }
        // form ads
        if (
          classificationStore.state.form &&
          classificationStore.state.form.ads
        ) {
          let entryId = result.data.id;
          try {
            eval(classificationStore.state.form && classificationStore.state.form.ads);
          } catch (ex) {
            this.$toasted.error(ex);
          }
        }

        this.updateParentView();
        this.closeForm();
      } catch(err) {
        console.error('submit', err);
        let message = getErrorMessage(this.selectedActivity.id, this.selectedActivity.standard);
        if (
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          message = `${message}. ${err.response.data.message}`;
        }
        this.formSubmitting = false;
        this.$toasted.error(message);
      }
    },
    async confirmUnsavedForm() {
      if (!this.selectedActivity || !this.selectedActivity.id) {
        return true;
      }

      const activityId = this.selectedActivity.id;

      if (activityId === "duplicate" || activityId === "delete") {
        return true;
      }

      /* design fields only — the raw snapshot diff also saw the bookkeeping the elements seed
         into formData on mount, so an untouched form asked to discard (SS05962) */
      const dirty = isFormDirty({
        form: classificationStore.state.form,
        formData: classificationStore.getters.formData,
        originalFormData: classificationStore.getters.originalFormData,
        activityId: activityId
      });

      if (dirty) {
        const res = await this.$confirmation.show({
          title: "Discard changes?",
          text: "You have unsaved changes. Are you sure you want to discard them?",
          buttons: [
            {
              title: "Cancel",
              bind: { "outline": true, "color": "primary" }
            },
            {
              title: "Discard",
              default: true,
              handler: ({ resolve }) => resolve(true)
            }
          ]
        });

        if (res === true) {
          return true;
        }

        return false;
      }

      return true;
    },
    async beforeCloseForm() {
      const confirmedClose = await this.confirmUnsavedForm(); 
      if (confirmedClose) {
        this.closeForm();
      }
    },
    closeForm() {
      let query = {};
      if (this.$route.query.l) query.l = this.$route.query.l;
      if (this.$route.query.t) query.t = this.$route.query.t;
      this.$router.push({ query: query });

      Object.assign(this.$data, this.$options.data.apply(this));
      this.isShow = false;
    },
    cancelActivityForm() {
      if (this.initialForm == "activity") {
        this.closeForm();
      } else {
        this.selectedActivity = null;

        if (this.fullView === true && !this.isViewRight) {
          this.fullView = false;
        } else if (this.fullView !== true && !this.isQuickViewRight) {
          this.fullView = true;
        }

        this.setEntryHeader(this.header);
        this.setRouter();
        this.loadViewForm();
      }
    },
    /**
     * An activity set to open a portal page opens it in a new tab instead of this form
     * (activityPortal.js); true when it did. Synchronous: callers make it before any await. Back
     * from the portal's tab, the list and the entry on screen show what its submit changed.
     */
    openPortalInstead(activity, moduleId, entries) {
      return openActivityPortalHere(activity, {
        moduleId,
        entries,
        routeName: this.$route && this.$route.name,
        onReturn: () => {
          if (this._isDestroyed) return;
          if (this.isShow && !this.selectedActivity && this.header && this.header.id) this.loadViewForm();
        },
      });
    },
    executeFormAction(action, actionType) {
      if (actionType == "standard" || actionType == "activity") {
        if (this.openPortalInstead(action, this.moduleId, this.items)) return;

        this.selectedActivity = action;

        if (this.selectedActivity.id == "create") {
          this.setEntryHeader();
          this.footer = {};
        }

        this.setRouter();
        this.loadActivityForm();
      } else if (actionType == "custom") {
        commons.executeEntryCustom({
          action: action,
          items: this.items,
          modal: this.$refs.ftsActionPageModal
        });
      } else if (actionType == "document" || actionType == "template") {
        if (action.hasForm) {
          this.$refs.ftsDocumentFormModal.show({
            moduleId: this.moduleId,
            listingId: this.listingId,
            document: action,
            items: this.items
          });
        } else {
          window.eventBus.$emit("showPDFDocument", {
            document: action,
            items: [{ id: this.header.id }],
            moduleId: this.moduleId,
          });
        }
      } else {
        console.warn(`Unhandled action type: ${actionType}`);
      }
    },
    toggleActivityViewForm(value) {
      this.isActivityViewForm = value;

      if (this.isActivityViewForm && this.viewData == null) {
        this.loadViewForm();
      }
    },
    async handleClickOutside(event) {
      const el = this.$el;
      if (el && el.contains(event.target)) {
        return;
      }

      const outsideClickEl = document.querySelector('[data-name="lite-layout-main"]');
      if (!outsideClickEl) {
        return;
      }

      if (
        event.target.closest('[data-click-stop]') || 
        event.target.closest('[data-ref="lite-design-overlay"]')
      ) {
        return;
      }

      if (outsideClickEl.contains(event.target)) {
        const confirmedClose = await this.confirmUnsavedForm(); 
        if (confirmedClose) {
          this.closeForm();
        }
      }
    },
    openActionDesignDrawer() {
      const args = {
        tab: 'action', 
        action: 'edit', 
        data: {
          id: this.selectedActivity?.id,
        }
      }

      window.eventBus.$emit("lite:openDesignWorkflowDrawer", args);
    }
  },
  computed: {
    isAdminUser() {
      return authorizationStore.getters.isAdminUser;
    },
    users() {
      return clientStore.getters.workspaceUsers;
    },
    states() {
      return this.designMode ?
        canvasDesignStore.getters.canvasStates :
        clientStore.getters.workspaceStates.filter((x) => x.module == this.moduleId);
    },
    module() {
      return clientStore.getters.workspaceModules.find((x) => x.id == this.moduleId);
    },
    moduleName() {
      return this.module && this.module.name;
    },
    isQuickViewRight() {
      return this.isRightOf('quickView');
    },
    isViewRight() {
      return this.isRightOf('view');
    },
    isCreateRight() {
      return this.isRightOf('create');
    },
    isCommentRight() {
      return this.isRightOf('comment');
    },
    isHistoryRight() {
      return this.isRightOf('history');
    },
    isAssignRight() {
      return this.isRightOf('assign');
    },
    isShareRight() {
      return this.isRightOf('share');
    },
    isChangeStatusRight() {
      return this.isRightOf('changeStatus');
    },
    isFormLoading() {
      return !!this.selectedActivity ? this.isActivityFormLoading : this.isViewFormLoading;
    },
    isMultiple() {
      return this.entries && this.entries.length > 1;
    },
    isError() {
      return Boolean(
        (!Boolean(this.selectedActivity) && this.viewFormError) ||
        (Boolean(this.selectedActivity) && this.activityFormError)
      );
    },
    formActions() {
      let list = [];
      const addItems = (items, actionType) => {
        if (items && items.length) {
          const [lastItem] = list.slice(-1);

          if (lastItem && lastItem.actionType !== actionType && list.length) {
            list.push({
              id: `action-divider-${list.length}`,
              optionRole: "divider"
            });
          }

          const mappedItems = items.map(x => ({...x, actionType}));
          list = list.concat(mappedItems);
        }
      }

      if (!this.selectedActivity && this.footer) {
        addItems(this.footer.activities, "activity");
        addItems(this.footer.documents, "template");
        addItems(this.footer.customs, "custom");

        if (this.footer.standards && this.footer.standards.length) {
          let standards = commons.standardActivities.filter((x) =>
            this.footer.standards.indexOf(x.id) > -1 &&
            x.id != "view" &&
            x.id != "create" &&
            x.id != "changeStatus" &&
            x.id != "assign"
          );

          addItems(standards, "standard");
        }
      }

      if (this.isShareRight) {
        addItems([{id: "copyLink"}], "standard");
        addItems([{id: "share"}], "standard");

        if (authorizationStore.getters.isInternal) {
          addItems([{id: "embedForm"}], "standard");
        }
      }

      if (!this.selectedActivity && this.isAdminUser) {
        const availableAdminFeatures = ["manage"];
        let adminFeatures = commons.adminFeatures.filter(x => availableAdminFeatures.includes(x.id));
        addItems(adminFeatures, "standard");
      }

      return list;
    },
    isDesignMode() {
      return clientStore.getters.liteDesignMode;
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        document.addEventListener("mousedown", this.handleClickOutside);
      } else {
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
    }
  },
  mounted() {
    classificationStore.dispatch("resetActivityForm");
    window.eventBus.$on("list-view-form:schemaUpdated", async (res)=>{
      if(!this.isShow) return; /* don't trigger reload of context inside this modal when it didnt open */
      if (this.selectedActivity && this.selectedActivity.id) {
        this.initialForm = "activity";
        await this.loadActivityForm();
      } else {
        await this.loadViewForm();
      }
    });

    window.eventBus.$on('listViewForm:open', async (res) => {
      // An activity set to open a portal page opens it in a new tab instead (the list sends its
      // portalId). First, before any await, or the browser's popup blocker stops the tab.
      if (res && res.activityId) {
        const entries = Array.isArray(res.entries) && res.entries.length ? res.entries : (res.id ? [res.id] : []);
        if (this.openPortalInstead({ id: res.activityId, portalId: res.portalId }, res.moduleId, entries)) return;
      }

      const current = {
        id: this.header && this.header.id ? this.header.id : null,
        activityId: this.selectedActivity ? this.selectedActivity.id : null,
        moduleId: this.moduleId,
        fullView: this.fullView
      }

      if (
        res.fromUrl &&
        res.id == current.id &&
        res.activityId == current.activityId &&
        (!res.moduleId || res.moduleId == current.moduleId)
      ) {
        return;
      }

      if (this.isShow) {
        this.resetContentScroll();
      }

      this.title = res.title;
      this.viewFormError = null;
      this.activityFormError = null;
      this.moduleId = res.moduleId;
      this.listingId = res.listingId;
      this.username = res.username;
      this.fullView = Boolean(res.fullView);

      if (Array.isArray(res.entries) && res.entries.length) {
        this.setEntryHeader(res.entries);
      } else {
        this.setEntryHeader(res);
      }

      this.initialFormData();
      this.isShow = true;

      if (res.callback && typeof res.callback === "function") {
        try {
          res.callback();
        } catch (error) {
          console.error("Failed to execute callback:", error);
        }
      }

      if (res.activityId && res.activityId !== 'view' && res.activityId !== 'quickView') {
        this.selectedActivity = commons.standardActivities.find(x => x.id == res.activityId);
        this.viewData = null;
        
        if (!this.selectedActivity) {
          this.selectedActivity = commons.adminFeatures.find(x => x.id == res.activityId);
        }
        
        if (!this.selectedActivity) {
          this.selectedActivity = { id: res.activityId, name: res.activityName };
        }
      } else {
        if (this.isActivityViewForm) {
          this.isActivityViewForm = false;
          this.viewData = null;
        }

        this.selectedActivity = null;
      }

      this.setRouter();

      if (this.selectedActivity && this.selectedActivity.id) {
        this.initialForm = "activity";
        await this.loadActivityForm();
      } else {
        await this.loadViewForm();
      }
    });
    window.eventBus.$on("list-view-form:close", () => {
      if (this.show) {
        this.closeForm();
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.eventBus.$off("listViewForm:open");
    window.eventBus.$off("list-view-form:close");
    window.eventBus.$off("list-view-form:schemaUpdated");
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars.scss" as *;

.fts-list-view-form {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 70%;
  max-width: 70%;
  min-width: 768px;
  right: 0;
  display: flex;
  flex-direction: column;
  box-shadow: var(--fts-elevation-5);
  background-color: var(--inistate-color-shade-white);
  z-index: $z-index-modal;
  .list-view-form__header {
    display: flex;
    align-items: flex-start;
    padding: 1rem;
  }
  .list-view-form__content {
    flex: 1;
    display: flex;
    overflow: hidden;
  }
  .list-view-form__overlay {
    @include flex-center-middle;
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: transparent;
    z-index: 1;
    cursor: wait;
  }

  .form-header__left {
    flex :1;
    min-width: 0;
  }
  .form-header__right {
    margin-left: 1rem;
    display: flex;
    align-items: center;
    .form-header__item {
      margin-right: 0.75rem;
    }
  }
  .form-header__uppr {
    display: flex;
    align-items: center;
    min-height: 24px;
    & + .form-header__lowr {
      margin-top: 4px;
    }
  }
  .form-header__lowr {
    display: flex;
    align-items: center;

    .fts-audit-group {
      .profile-name, 
      .audit-group-date {
        color: var(--inistate-text-secondary);
      }
    }
  }

  .form-header__default-label {
    @include text-overflow-ellipsis;
    font-weight: var(--inistate-font-weight-bold);
    font-size: var(--inistate-heading-text-16);
    line-height: var(--inistate-heading-text-16--line-height);
    color: var(--inistate-text-primary);
  }

  .form-header__activity {
    @extend .form-header__default-label;
  }

  .form-header__title {
    @extend .form-header__default-label;
    &:not(:first-child) {
      &::before {
        content: "|";
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }

  .form-header__state {
    margin-left: 8px;
    padding-top: 2px;
    padding-bottom: 2px;
    > div {
      font-weight: var(--inistate-font-weight-light);
      font-size: var(--inistate-label-text-12);
      line-height: var(--inistate-label-text-12--line-height);
    }
  }

  .form-header__design-btn {
    flex-shrink: 0;
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    border-radius: var(--inistate-rounded-4);
    background-color: transparent;
    color: var(--inistate-icon-secondary);
    transition: background-color 0.3s ease, color 0.3s ease;
    @include user-select-none;
    > span {
      font-size: var(--inistate-label-text-16);
    }
    &:hover {
      background-color: var(--inistate-color-neutral-100);
      color: var(--inistate-icon-primary);
      cursor: pointer;
    }
  }

  .form-header__action-btn {
    flex-shrink: 0;
    height: 36px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--inistate-rounded-4);
    background-color: transparent;
    color: var(--inistate-icon-secondary);
    transition: background-color 0.3s ease, color 0.3s ease;
    @include user-select-none;

    > span {
      font-size: 20px;
    }

    &:hover {
      background-color: var(--inistate-background-secondary);
      color: var(--inistate-icon-primary);
      cursor: pointer;
    }

    &--active {
      background-color: var(--inistate-background-secondary);
      color: var(--inistate-icon-primary);
    }
  }

  .form-header__audit {
    font-size: var(--inistate-label-text-12);
    line-height: var(--inistate-label-text-12--line-height);
  }

  .form-content__form {
    flex: 1;
    display: flex;
    flex-direction: column;

    .fts-form-element.compact-form-design > .fts-form-element-wrapper {
      flex-wrap: wrap;
      & > .fts-form-label.form-label--icon-right,
      & > .fts-form-label.form-label--left {
        min-width: 100%;
        max-width: 100%;
        width: 100%;
        margin-right: 0;
        padding-left: 0;
        padding-right: 0;
        text-align: left;
        flex-direction: row;
        .form-label__icon {
          margin-left: 0;
          margin-right: 0.375rem;
        }
        .form-label__label {
          text-align: left;
        }
      }
    }

    .fts-form-control,
    .fts-dropdown__select .vs-input,
    .fts-dropdown-user__select .vs-input,
    .fts-file-upload .file-upload__header .file-upload-uploader .fts-file-dropzone,
    .fts-file-upload .file-upload__header .file-upload-uploader .file-upload-action,
    .fts-table-edit {
      background-color: var(--inistate-color-shade-white);
    }

    .fts-form-control,
    .fts-dropdown__select .vs-toggle,
    .fts-dropdown-user__select .vs-toggle,
    .fts-file-upload .file-upload__header .file-upload-uploader .fts-file-dropzone,
    .fts-file-upload .file-upload__header .file-upload-uploader .file-upload-action {
      border-radius: var(--inistate-rounded-4);
    }

    .fts-display:not(.form-display-borderless) {
      > .fts-display-form-control,
      > .display-content {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  .form-content__form-container {
    padding: 8px 16px 16px 16px;
  }

  .form-content__form-view {
    .form-element-content {
      overflow-x: auto;
    }

    .fts-form-label,
    .fts-table-edit > tr > th .col-label {
      color: var(--inistate-text-secondary);
    }
  }

  .form-content__form-activity {
    .fts-form-label,
    .fts-table-edit > thead > tr > th .col-label,
    .fts-table-edit > tr > th .col-label {
      color: var(--inistate-text-primary);
    }
  }

  .form-content__form-view,
  .form-content__form-activity {
    .fts-display {
      color: var(--inistate-text-primary);
    }
  }

  .form-content__form-footer {
    flex: 1 1 0%;
    position: sticky;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: flex-end;
    padding: 1rem;
    background-color: var(--inistate-color-shade-white);
    > * {
      flex: 1;
      max-width: 100%;
    }
  }

  .form__content-details {
    margin-bottom: 20px;
    border-radius: var(--inistate-rounded-8);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    &:hover {
      background-color: var(--inistate-color-neutral-50);
    }
    &.form__content-details--active {
      background-color: var(--inistate-color-neutral-50);
      .form__content-details-toggle-icon span {
        transform: rotate(-180deg);
      }
    }
  }

  .form__content-details-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    color: var(--inistate-text-secondary);
    @include user-select-none;
    &:hover {
      cursor: pointer;
    }
  }
  .form__content-details-toggle-label {
    min-height: 36px;
    display: flex;
    align-items: center;
    font-weight: var(--inistate-font-weight-medium);
    font-size: var(--inistate-paragraph-text-16);
    line-height: var(--inistate-paragraph-text-16--line-height);
  }
  .form__content-details-toggle-icon {
    > span {
      font-size: 20px;
      transition: transform 0.3s ease;
    }
  }

  .form__content-details-content {
    padding: 16px;
    border-top: 1px solid var(--inistate-color-neutral-100);
    overflow-x: auto;
  }
  .form__content-details-content-loading {
    height: 60px;
  }
  
  .fts-history-lite {
    &.form-content__history {
      margin: 8px 16px 16px 8px;
    }
  }

  .dv-form-history {
    &.dv-form-history--count {
      position: relative;
      padding-right: 0.625rem;
    }
  }
  .dv-form-history-count {
    @include absolute-center-y;
    left: 1.625rem;
    min-width: 1rem;
    padding: 0 0.125rem;
    border: 1px solid transparent;
    border-radius: 10em;
    font-size: 0.75rem;
    color: var(--fts-default);
    text-align: center;
    transition: all 0.3s ease-in-out;
  }
  .dv-form-activity-content {
    margin-bottom: 1.5rem;
  }
  .dv-form-activity-label {
    font-size: 1rem;
    line-height: 1.5rem;
    color: var(--fts-text);
  }
  .dv-form-activity-label-group {
    display: flex;
    align-items: center;
    .dv-form-activity-label {
      margin-right: 0.5rem;
    }
  }
  .dv-form-activity-state {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .dv-form-error {
    padding: 2rem;
    text-align: center;
  }
  .dv-form-error-icon {
    height: 80px;
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.25rem;
    border: 2px solid var(--fts-danger);
    border-radius: 50%;
    color: var(--fts-danger);
    > svg {
      color: inherit;
      font-size: 2.5rem;
    }
  }
  .dv-form-error-title {
    margin-bottom: 0.75rem;
    color: var(--fts-danger);
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.75rem;
    word-break: break-word;
  }
  .dv-form-error-description {
    color: var(--fts-default);
    font-size: 0.875rem;
    line-height: 1.25rem;
    word-break: break-word;
  }
}

/* ==========================================================================
   Calm density — P1 (2026-09-05)
   docs/frontend-lite-form-calm-density-proposal.md, rulings F1–F12 (recommended options;
   fields side by side per F3c/F4c). Class-level only: nothing added, removed or re-parented —
   every element, class and text the Playwright suite pins (form-header__action-btn--active,
   the "Details" toggle, .fts-form-group rows, .comment-btn, .history-header-title…) survives.
   Each block names its ruling so a different call is a block deletion.
   ========================================================================== */
.fts-list-view-form {

  /* ---- F1 · shell: hairline edge + DS soft shadow instead of elevation-5 ---- */
  border-left: 1px solid var(--fts-gray-200);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.05), 0 6px 16px -8px rgba(0, 0, 0, 0.08);

  /* ---- F2 · header: one 48px line ---- */
  .list-view-form__header {
    min-height: 48px;
    align-items: center;
    padding: 0 12px 0 24px;
    border-bottom: 1px solid var(--fts-gray-100);
  }
  .form-header__left {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    column-gap: 10px;
  }
  .form-header__uppr {
    min-height: 0;
    align-items: baseline;
    gap: 8px;
    > *:not(:first-child) { margin-top: 0; }
  }
  .form-header__activity,
  .form-header__title,
  .form-header__default-label {
    font-size: 0.9375rem;
    line-height: 20px;
    font-weight: 600;
    color: var(--fts-text);
  }
  .form-header__title:not(:first-child) { font-weight: 500; }
  .form-header__state {
    margin-left: 0;
    padding: 0;
    align-self: center;
    > div {
      font-size: 0.75rem;
      line-height: 22px;
      font-weight: 500;
    }
  }
  .form-header__lowr {
    margin-top: 0;
    &::before {
      content: "·";
      margin-right: 8px;
      color: var(--fts-gray-300);
    }
    /* create has no audit: the line renders empty, so no separator either */
    &:not(:has(*))::before { content: none; }
    .fts-audit-group .profile-name,
    .fts-audit-group .audit-group-date { color: var(--inistate-text-secondary); }
  }
  .form-header__audit { font-size: 0.75rem; line-height: 16px; }
  /* F11 — design pencils at rest 0.35 */
  .form-header__design-btn {
    height: 24px;
    width: 24px;
    margin-left: 0;
    opacity: 0.35;
    transition: opacity 0.15s ease;
    &:hover { opacity: 1; background-color: transparent; }
  }
  .form-header__right {
    margin-left: auto;
    align-self: center;
    gap: 2px;
    .form-header__item { margin-right: 4px; }
  }
  .form-header__action-btn {
    position: relative;
    height: 32px;
    width: 32px;
    color: var(--fts-default);
    > span { font-size: 18px; }
    &:hover { background-color: transparent; color: var(--fts-text); }
    &--active {
      background-color: transparent;
      color: var(--fts-text);
      &::after {
        content: "";
        position: absolute;
        left: 8px;
        right: 8px;
        bottom: 3px;
        height: 2px;
        background-color: var(--fts-text);
      }
    }
  }

  /* ---- F1 · content: form column on a 640px measure, history column on a hairline ---- */
  .form-content__form-container {
    max-width: 688px;   /* 640 measure + 24px either side */
    padding: 12px 24px 16px;
  }

  /* ---- F3c / F4c · fields side by side: 160px label column, control fills the measure ----
     The label already renders in its left mode (form-label--left form-label--py); the rule
     above this block forced both halves to 100% and stacked them. Restore the row. */
  .form-content__form .fts-form-element.compact-form-design > .fts-form-element-wrapper {
    flex-wrap: nowrap;
    align-items: flex-start;
    & > .fts-form-label.form-label--icon-right,
    & > .fts-form-label.form-label--left {
      flex: 0 0 160px;
      min-width: 160px;
      max-width: 160px;
      width: 160px;
      margin-right: 12px;
      padding: 8px 0 0;           /* 16px label line centred on a 32px control */
      font-size: 0.75rem;
      line-height: 16px;
      font-weight: 400;
      color: var(--fts-form-label);
      .form-label__label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    & > .form-element-content,
    & > *:not(.fts-form-label) {
      flex: 1 1 0;
      min-width: 0;
      width: auto;
    }
    /* span rows: wide or tall controls keep the label above, full width */
    &:has(textarea, .fts-table-edit, .fts-table-view, .fts-file-upload, .file-display, .image-content-wrapper, .signature-display, .display-content, .fts-editor, .fts-rich-editor, .ql-editor, .form-element-checkbox-group) {
      flex-wrap: wrap;
      & > .fts-form-label.form-label--icon-right,
      & > .fts-form-label.form-label--left {
        flex-basis: 100%;
        min-width: 100%;
        max-width: 100%;
        width: 100%;
        margin-right: 0;
        margin-bottom: 4px;
        padding-top: 0;
      }
      & > .form-element-content,
      & > *:not(.fts-form-label) { flex-basis: 100%; }
    }
  }
  .form-content__form .fts-form-element .fts-form-label,
  .form-content__form-view .fts-form-label,
  .form-content__form-activity .fts-form-label {
    color: var(--fts-form-label);
  }
  .form-content__form .fts-form-group { margin-bottom: 8px; }

  /* F3c — 32px controls, 13px, DS focus */
  .form-content__form {
    .fts-form-control {
      min-height: 32px;
      height: 32px;
      padding: 0 10px;
      font-size: 0.8125rem;
      line-height: 20px;
      border-color: var(--fts-gray-200);
      &:focus {
        border: 2px solid var(--fts-primary);
        padding: 0 9px;
        box-shadow: none;
      }
    }
    textarea.fts-form-control {
      height: auto;
      min-height: 72px;
      padding: 6px 10px;
      line-height: 20px;
      &:focus { padding: 5px 9px; }
    }
    .fts-dropdown__select .vs-toggle,
    .fts-dropdown-user__select .vs-toggle {
      min-height: 32px;
      padding-top: 5px;        /* 5 + 20 line + 5 + 2 border = 32; multi-tag rows still grow */
      padding-bottom: 5px;
      line-height: 20px;
      font-size: 0.8125rem;
      border-color: var(--fts-gray-200);
    }
    /* the search input INSIDE the toggle must not carry its own padding, or the two nest to 44px */
    .fts-dropdown__select .vs-toggle .vs-input,
    .fts-dropdown-user__select .vs-toggle .vs-input {
      min-height: 20px;
      height: 20px;
      padding-top: 0;
      padding-bottom: 0;
      line-height: 20px;
      font-size: 0.8125rem;
    }
    .fts-file-upload .file-upload__header .file-upload-uploader .fts-file-dropzone,
    .fts-file-upload .file-upload__header .file-upload-uploader .file-upload-action {
      border-color: var(--fts-gray-200);
    }
    .fts-form-error { font-size: 0.75rem; line-height: 16px; }
  }

  /* F4c — view mode: a fact is a 32px ledger line on a hairline */
  .form-content__form-view {
    .fts-form-group {
      margin-bottom: 0;
      border-bottom: 1px solid var(--fts-gray-100);
    }
    .fts-display {
      min-height: 32px;
      padding: 6px 0;
      font-size: 0.8125rem;
      line-height: 20px;
      color: var(--fts-text);
      .fts-display-form-control {
        padding-top: 0;
        padding-bottom: 0;
        min-height: 20px;
      }
      /* P1b — an empty fact reads "—", not a blank line. An empty display renders as
         `<div class="fts-display"><!----> </div>` (a comment and whitespace, so :empty never
         matches); "no element child" is the reliable test. */
      &:not(:has(*))::before {
        content: "—";
        color: var(--fts-default);
      }
    }
    .fts-form-element.compact-form-design > .fts-form-element-wrapper > .fts-form-label.form-label--left {
      padding-top: 8px;
    }
  }
  /* sections: box → group label */
  .form-content__form .fts-form-container .fts-form-section {
    border: 0;
    .form-section-header {
      padding: 0;
      border: 0;
      .form-section-header-title {
        padding: 20px 0 6px;
        font-size: 0.625rem;
        line-height: 16px;
        font-weight: 500;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--fts-form-helper);
      }
    }
  }

  /* ---- F5 · Details: a 36px disclosure row, no card ---- */
  .form__content-details {
    margin-bottom: 12px;
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
    &:hover,
    &.form__content-details--active { background-color: transparent; }
  }
  .form__content-details-toggle {
    min-height: 36px;
    padding: 0;
    border-bottom: 1px solid var(--fts-gray-100);
    color: var(--fts-text);
  }
  .form__content-details-toggle-label {
    min-height: 0;
    font-size: 0.8125rem;
    line-height: 20px;
    font-weight: 500;
  }
  .form__content-details-toggle-icon {
    color: var(--fts-default);
    > span { font-size: 16px !important; }
  }
  .form__content-details-content {
    padding: 12px 0 0;
    border-top: 0;
  }

  /* ---- F6 · comment prompt: a 32px ghost row ---- */
  .form-content__form-activity .fts-comment .comment-toggle,
  .form-content__form-view .fts-comment .comment-toggle,
  .dv-form-activity .fts-comment .comment-toggle {
    min-height: 32px;
    margin-top: 8px;
    padding: 6px 0;
    font-size: 0.8125rem;
    line-height: 20px;
    color: var(--fts-default);
    border-radius: 0;
    transition: color 0.15s ease;
    &:hover { background-color: transparent; color: var(--fts-text); }
  }

  /* ---- F7 · footer: 44px, one accent ---- */
  .form-content__form-footer {
    flex: 0 0 auto;           /* the base rule's flex:1 would grow the strip to fill the column */
    margin-top: auto;
    min-height: 44px;
    display: flex;
    align-items: center;
    padding: 0 12px 0 24px;
    border-top: 1px solid var(--fts-gray-100);
    .fts-form-footer,
    .fts-form-footer-buttons { width: 100%; }
    .fts-btn {
      height: 32px;
      min-height: 32px;
      padding: 0 12px;
      font-size: 0.8125rem;
      letter-spacing: 0;
      text-transform: none;
    }
    .form-footer__l { font-size: 0.8125rem; color: var(--inistate-text-secondary); }
    /* view: first activity is the accent, the rest outlined in ink, docs/customs ghosts */
    .form-footer-button-container {
      max-height: 32px;
      gap: 4px;
      .fts-btn.btn-activity {
        background-color: transparent !important;
        border: 1px solid var(--fts-gray-200) !important;
        color: var(--fts-text) !important;
        .btn-activity-label { color: inherit; }
      }
      > .fts-btn.btn-activity.form-footer-button:first-child {
        background-color: var(--fts-primary) !important;
        border-color: var(--fts-primary) !important;
        color: #fff !important;
      }
      .fts-btn.btn-activity:not(.form-footer-button) {
        border-color: transparent !important;
        color: var(--fts-default) !important;
        > svg { color: inherit; }
        &:hover { color: var(--fts-text) !important; }
      }
    }
    .form-toggle-more-btn {
      height: 32px;
      min-width: 32px;
      padding: 0 6px;
      color: var(--fts-default);
      &:hover { background-color: transparent; color: var(--fts-text); }
    }
    .form-footer-design-btn { opacity: 0.35; &:hover { opacity: 1; } }
  }

  /* ---- F8 · history / comment column: 400px on a hairline, no card ---- */
  .fts-history-lite.form-content__history {
    flex: 0 0 400px;
    min-width: 400px;
    max-width: 400px;
    margin: 0;
    border-radius: 0;
    border-left: 1px solid var(--fts-gray-100);
  }
  .fts-history-lite {
    .history-header {
      min-height: 48px;
      align-items: center;
      padding: 0 8px 0 16px;
      border-bottom: 1px solid var(--fts-gray-100);
    }
    .history-header__l {
      min-height: 0;
      align-items: baseline;
      gap: 6px;
    }
    .history-header-title {
      font-size: 0.8125rem;
      line-height: 20px;
      font-weight: 600;
      color: var(--fts-text);
    }
    .history-header-count {
      height: auto;
      min-width: 0;
      padding: 0;
      border-radius: 0;
      background-color: transparent;
      color: var(--inistate-text-secondary);
      font-size: 0.75rem;
      font-weight: 400;
      font-variant-numeric: tabular-nums;
    }
    .history-header-btn {
      height: 32px;
      width: 32px;
      color: var(--fts-default);
      > span { font-size: 18px; }
      &:hover,
      &--active { background-color: transparent; color: var(--fts-text); }
    }
    .history-section { padding: 4px 8px 8px; }
    /* F8b — empty states: one line, no illustration */
    .history-section-intro {
      height: auto;
      padding: 8px 8px 12px;
      text-align: left;
      align-items: flex-start;
    }
    .history-section-intro-state,
    .history-section-intro-icon { display: none; }
    .history-section-intro-title {
      margin-bottom: 2px;
      font-size: 0.8125rem;
      line-height: 20px;
      font-weight: 500;
    }
    .history-section-intro-description {
      max-width: none;
      font-size: 0.75rem;
      line-height: 16px;
    }

    /* ---- F9 · composer: footed on a hairline, no box; Send ghost → ink ---- */
    .history-footer {
      padding: 0;
      border-top: 1px solid var(--fts-gray-100);
      .fts-comment .comment-wrapper .comment-content {
        border: 0;
        border-radius: 0;
        background-color: transparent;
      }
      .fts-comment .comment-editor {
        min-height: 36px;
        padding: 8px 16px;
        font-size: 0.8125rem;
      }
      .fts-comment .comment-action-bar {
        min-height: 32px;
        padding: 0 8px 0 16px;
        border-top: 0;
        .comment-action-icon { color: var(--fts-default); }
      }
      .comment-btn {
        color: var(--fts-text);
        font-size: 18px;
        transition: color 0.15s ease;
        &.comment-btn--disabled { color: var(--fts-gray-300); }
      }
    }
  }

  /* ---- F10 · standard activities and errors as ledger lines ---- */
  .dv-form-activity-content { margin-bottom: 12px; }
  .dv-form-activity-label {
    font-size: 0.8125rem;
    line-height: 20px;
    color: var(--fts-text);
    &.fts-text-center { text-align: left !important; }
  }
  .dv-form-activity-state { align-items: flex-start; }
  .dv-form-error {
    padding: 12px 0;
    text-align: left;
  }
  .dv-form-error-icon { display: none; }
  .dv-form-error-title {
    margin-bottom: 2px;
    font-size: 0.8125rem;
    line-height: 20px;
  }
  .dv-form-error-description {
    font-size: 0.75rem;
    line-height: 16px;
    color: var(--inistate-text-secondary);
  }
}
</style>